import { Button, Typography } from "@mui/material";

export default function GenericButton({
  variant = "contained",
  onClick,
  disabled,
  children,
  sx,
}) {
  return (
    <Button
      variant={variant}
      className="group normal-case rounded-full w-full p-3"
      sx={sx}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography className="text-sm font-normal group-hover:font-semibold">
        {children}
      </Typography>
    </Button>
  );
}
